export const eventOrder = (a, b) => {
    const dateA = a.start ? new Date(a.start).toDateString() : "";
    const dateB = b.start ? new Date(b.start).toDateString() : "";
    if (dateA !== dateB) return new Date(a.start) - new Date(b.start);

    const pa = a.extendedProps.parentId;
    const pb = b.extendedProps.parentId;

    if (pa !== pb) {
        if (pa === null && pb !== null) return -1;
        if (pa !== null && pb === null) return 1;
        if (pa !== null && pb !== null) return pa - pb;
    }

    const wa = a.extendedProps.tipo === "EVENTO" ? 0 : 1;
    const wb = b.extendedProps.tipo === "EVENTO" ? 0 : 1;
    if (wa !== wb) return wa - wb;

    return (a.title || "").localeCompare(b.title || "");
};
